import Linux from '../../assets/images/svg/linux-regular.svg';
import MacOS from '../../assets/images/svg/MacOSX.svg';
import Windows from '../../assets/images/windows.png';

export const apiUrl = process.env.REACT_APP_CONFIG_BASE_URL;

export const validationMessagesConfig = {
  email: 'Por favor, introduzca un email',
  provider: 'Por favor, seleccione un proveedor',
  policy: 'Por favor, lea y acepte nuestros términos y condiciones',
};

export const applicationConfig = [
  {
    appLink: process.env.REACT_APP_WINDOWS_APP_DOWNLOAD_LINK,
    appName: 'Windows',
    imageSrc: Windows,
    imageAlt: 'Windows Desktop App Link',
    manualLink: process.env.REACT_APP_WINDOWS_INSTALLATION_MANUAL_LINK,
    manualName: 'Windows'
  },
  {
    appLink: process.env.REACT_APP_IOS_INTEL_APP_DOWNLOAD_LINK,
    appName: 'Mac Intel',
    imageSrc: MacOS,
    imageAlt: 'Mac Intel Desktop App Link',
    manualLink: process.env.REACT_APP_MACOS_INSTALLATION_MANUAL_LINK,
    manualName: 'MacOS'
  },
  {
    appLink: process.env.REACT_APP_IOS_SILICON_APP_DOWNLOAD_LINK,
    appName: 'Mac',
    imageSrc: MacOS,
    imageAlt: 'Mac Apple Silicon Desktop App Link',
    manualLink: process.env.REACT_APP_MACOS_INSTALLATION_MANUAL_LINK,
    manualName: 'MacOS'
  },
  {
    appLink: process.env.REACT_APP_LINUX_DEB_APP_DOWNLOAD_LINK,
    appName: 'Linux DEB',
    imageSrc: Linux,
    imageAlt: 'Linux DEB Desktop App Link',
    manualLink: process.env.REACT_APP_LINUX_INSTALLATION_MANUAL_LINK,
    manualName: 'Linux'
  },
  {
    appLink: process.env.REACT_APP_LINUX_RPM_APP_DOWNLOAD_LINK,
    appName: 'Linux RPM',
    imageSrc: Linux,
    imageAlt: 'Linux RPM Desktop App Link',
    manualLink: process.env.REACT_APP_LINUX_INSTALLATION_MANUAL_LINK,
    manualName: 'Linux'
  }
];

export const manualAppLinks = [
  {
    link: process.env.REACT_APP_WINDOWS_APP_MANUAL_LINK,
    name: 'Windows',
  },
  {
    link: process.env.REACT_APP_MACOS_APP_MANUAL_LINK,
    name: 'Mac',
  },
  {
    link: process.env.REACT_APP_LINUX_APP_MANUAL_LINK,
    name: 'Linux',
  }
];

export const manualInstallationLinks = [
  {
    link: process.env.REACT_APP_WINDOWS_INSTALLATION_MANUAL_LINK,
    name: 'Windows',
  },
  {
    link: process.env.REACT_APP_MACOS_INSTALLATION_MANUAL_LINK,
    name: 'Mac',
  },
  {
    link: process.env.REACT_APP_LINUX_INSTALLATION_MANUAL_LINK,
    name: 'Linux',
  }
];

export const otherProviderValue = 'otro_cl';

export const providersConfig = [
  { label: 'Telefónica', value: 'telefonica_cl' },
  { label: 'Entel', value: 'entel_cl' },
  { label: 'WOM', value: 'wom_cl' },
  { label: 'Claro', value: 'claro_cl' },
  { label: 'VTR', value: 'vtr_cl' },
  { label: 'Mundo', value: 'mundo_cl' },
  { label: 'GTD', value: 'gtd_cl' },
  { label: 'Telsur', value: 'telsur_cl' },
  { label: 'Otro', value: otherProviderValue }
];
